
import { useState } from 'react';
import Hero from './components/Hero';
import EventInfo from './components/EventInfo';
import Registration from './components/Registration';
import Route from './components/Route';
import Sponsors from './components/Sponsors';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <EventInfo />
      <Registration />
      <Route />
      <Sponsors />
      <Footer />
    </div>
  );
}